export default __webpack_public_path__ + "static/media/004.6409d9a1.jpg";